import Navbar from './Coponents/Navbar/Navbar';
import Hero from './Coponents/Hero/Hero';
import About from './Coponents/About/About';
import Services from './Coponents/Services/Services';
import MyWork from './Coponents/MyWork/MyWork';
import Contact from './Coponents/Contact/Contact';

function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <Services />
      <MyWork />
      <Contact />
    </>
  );
}

export default App;
